export const TECHNICAL_ISSUE_ERROR = 'technical-issue';
